<template>
  <div class="d-flex mr-3">
    <v-btn
      class="decrementNumber"
      fab
      xSmall
      elevation="0"
      color="lightBlue"
      @click="decrease"
    >
      <v-icon>
        mdi-minus
      </v-icon>
    </v-btn>
    <div class="quantity">{{ value }}</div>
    <v-btn
      class="incrementNumber"
      fab
      xSmall
      elevation="0"
      color="lightBlue"
      @click="increase"
    >
      <v-icon>
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'TheQuantity',
  props: {
    value: { type: Number, default: 1 }
  },
  methods: {
    increase: function () {
      this.$emit('input', this.value + 1);
    },
    decrease: function () {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  }
};
</script>
<style scoped>
.decrementNumber {
    border-top-left-radius: 20px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 20px;
}
.incrementNumber {
    border-top-left-radius: 0px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 0px;
}
.quantity{
    width: 40px;
    background: #f0f0f0;
    height: 32px;
    text-align: center;
    padding: 4px;
}
</style>
